import React, { useMemo } from "react"

import useAdTargeting from "components/article/hooks/useAdTargeting"
import { NetworkAdUnit } from "./styles"

const TopAd = ({ article, ...props }) => {
  const { nsfw } = article
  const targetingOptions = useMemo(() => useAdTargeting(article), [article])

  return (
    <NetworkAdUnit
      placementName="mindbodygreen-com_ATF_leaderboard"
      nsfw={nsfw}
      hideTitle
      {...props}
      targetingOptions={targetingOptions}
    />
  )
}

export default TopAd
